(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 52904:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(36135);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45680);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var _screens_errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52544);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8881);
/* harmony import */ var _services_sentry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52353);
/* harmony import */ var _services_openreplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92268);
/* harmony import */ var _hooks_useSegment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59945);
/*
 * File: _error.js
 * Project: meki
 * File Created: Saturday, 16th January 2021 10:04:31 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Tuesday, 24th January 2023 5:24:26 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-return */ /* eslint-disable @typescript-eslint/restrict-template-expressions */ 








var MyError = function(param) {
    var hasGetInitialPropsRun = param.hasGetInitialPropsRun, err = param.err;
    var trackIssue = (0,_services_openreplay__WEBPACK_IMPORTED_MODULE_5__/* .useOpenReplayTracking */ .WK)().trackIssue;
    var track = (0,_hooks_useSegment__WEBPACK_IMPORTED_MODULE_6__/* .useSegment */ .K)().track;
    _utils__WEBPACK_IMPORTED_MODULE_3__/* .Console.error */ .Mn.error({
        msg: "FATAL ERROR",
        hasGetInitialPropsRun: hasGetInitialPropsRun,
        err: err
    });
    void trackIssue("Error screen", {
        err: err,
        hasGetInitialPropsRun: hasGetInitialPropsRun
    });
    void track("Error generico");
    if (!hasGetInitialPropsRun && err) {
        // getInitialProps is not called in case of
        // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
        // err via _app.js so it can be captured
        void (0,_services_sentry__WEBPACK_IMPORTED_MODULE_4__/* .getSentry */ .$)().then(function(Sentry) {
            Sentry.captureException(err);
        });
    // Flushing is not required in this case as it only happens on the client
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_errors__WEBPACK_IMPORTED_MODULE_2__/* .ErrorScreen */ .C, {});
};
MyError.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(param) {
        var res, err, asPath, errorInitialProps, Sentry;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    res = param.res, err = param.err, asPath = param.asPath;
                    _utils__WEBPACK_IMPORTED_MODULE_3__/* .Console.error */ .Mn.error({
                        msg: "FATAL ERROR, getInitialProps",
                        err: err,
                        asPath: asPath
                    });
                    return [
                        4,
                        next_error__WEBPACK_IMPORTED_MODULE_1__["default"].getInitialProps({
                            res: res,
                            err: err
                        })
                    ];
                case 1:
                    errorInitialProps = _state.sent();
                    // Workaround for https://github.com/vercel/next.js/issues/8592, mark when
                    // getInitialProps has run
                    errorInitialProps.hasGetInitialPropsRun = true;
                    return [
                        4,
                        (0,_services_sentry__WEBPACK_IMPORTED_MODULE_4__/* .getSentry */ .$)()
                    ];
                case 2:
                    Sentry = _state.sent();
                    if (!err) return [
                        3,
                        4
                    ];
                    Sentry.captureException(err);
                    // Flushing before returning is necessary if deploying to Vercel, see
                    // https://vercel.com/docs/platform/limits#streaming-responses
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        errorInitialProps
                    ];
                case 4:
                    // If this point is reached, getInitialProps was called without any
                    // information about what the error might be. This is unexpected and may
                    // indicate a bug introduced in Next.js, so record it in Sentry
                    Sentry.captureException(new Error("_error.js getInitialProps missing data at path: ".concat(asPath)));
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 5:
                    _state.sent();
                    return [
                        2,
                        errorInitialProps
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (MyError);


/***/ }),

/***/ 52544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ ErrorScreen; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/errors/error.styles.ts



var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh"
});
var ErrorContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "fit-content",
    width: "600px"
});
var IconContainer = (0,styled/* default */.Z)("div")({
    position: "relative",
    width: "246px",
    height: "145px",
    marginBottom: "30px"
});
var MainTextContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column"
    }, theme.breakpoints.down(570), {
        padding: "0px 90px"
    });
});
var TextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 400,
        fontSize: "30px",
        lineHeight: "45px",
        textAlign: "center",
        color: "#414046"
    }, theme.breakpoints.down(570), {
        fontSize: "16px",
        lineHeight: "24px"
    });
});
var LinkTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        textAlign: "center",
        color: "#0A7ABE",
        textDecoration: "underline",
        cursor: "pointer"
    }, theme.breakpoints.down(570), {
        fontSize: "14px",
        lineHeight: "21px"
    });
});
var SmallTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 300,
        fontSize: "16px",
        lineHeight: "24px",
        textAlign: "center",
        color: "#414046"
    }, theme.breakpoints.down(570), {
        fontSize: "14px",
        lineHeight: "21px"
    });
});
var LinkContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "row",
        gap: "6px",
        marginTop: "40px"
    }, theme.breakpoints.down(570), {
        flexDirection: "column",
        gap: "0px"
    });
});


// EXTERNAL MODULE: ./src/screens/home/components/homeNavBar.tsx + 1 modules
var homeNavBar = __webpack_require__(88617);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Screen.ts
var Screen = __webpack_require__(42101);
;// CONCATENATED MODULE: ./src/screens/errors/error.tsx








var ErrorScreen = function() {
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    track(Screen/* ScreenEventType.ScreenGenericErrorView */.O.ScreenGenericErrorView);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homeNavBar/* HomeNavBar */.y, {
                isVisible: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/images/errorIcon.webp",
                                alt: "error",
                                layout: "fill",
                                objectFit: "contain",
                                priority: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                children: "Ha ocurrido un problema y estamos trabajando para solucionarlo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTypography, {
                                    onClick: function() {
                                        window.open("https://api.whatsapp.com/send?phone=".concat(environment/* PHONE_NUMBER.CLEAN */.UE.CLEAN, "&text=").concat(encodeURI("Hola! Tuve un problema con la pagina. Necesito ayuda con ")), "_blank");
                                    },
                                    children: "Pincha aqu\xed"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTypography, {
                                    children: "si quieres recibir ayuda de un asistente"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/errors/index.tsx
/*
 * File: index.tsx
 * Project: meki
 * File Created: Wednesday, 20th January 2021 11:01:16 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Wednesday, 6th October 2021 10:41:56 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


/***/ }),

/***/ 88617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ HomeNavBar; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(26993);
;// CONCATENATED MODULE: ./src/screens/home/components/homeNavBar.styles.ts
/*
 * File: homeNavBa
 * Project: meki
 * File Created: Thursday, 28th July 2022 4:01:26 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 18th January 2023 12:23:58 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


var RootDiv = (0,styled/* default */.Z)("div")({
    flexGrow: 1,
    "& .MuiButton-root": {
        textTransform: "None"
    },
    position: "sticky",
    top: 0,
    zIndex: 1100
});
var HeaderAppBar = (0,styled/* default */.Z)(AppBar/* default */.Z)(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        top: 0,
        bottom: "auto",
        height: 64,
        background: theme.palette.common.white,
        boxShadow: elevation ? "0px 1px 10px rgb(0 0 0 / 12%)" : "none",
        transition: "background-color 0.4s",
        backdropFilter: "blur(5px)",
        "@media (min-width: 800px)": {
            height: "inherit"
        },
        position: "relative"
    };
});
var HeaderToolbar = (0,styled/* default */.Z)(Toolbar/* default */.Z)({
    justifyContent: "space-between",
    minHeight: 64,
    backgroundColor: "transparent",
    paddingRight: 0,
    paddingLeft: "12px"
});
var PositionDivLeft = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flex: 0,
        position: "absolute",
        left: 20,
        zIndex: 1
    }, theme.breakpoints.down("md"), {
        zIndex: 0,
        left: 0,
        position: "unset"
    });
});
var PositionDivRight = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flex: 0,
        position: "absolute",
        right: 12,
        zIndex: 1
    }, theme.breakpoints.down("md"), {
        zIndex: 3000,
        right: 0,
        position: "unset"
    });
});
var HeaderLeftDiv = (0,styled/* default */.Z)("div")({
    zIndex: 0,
    display: "flex",
    alignItems: "center"
});
var BackIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function() {
    return {
        color: "#004C8C"
    };
});
var HeaderRightComponent = (0,styled/* default */.Z)("div")({
    display: "flex",
    alignItems: "center"
});
var MekiLogoDiv = (0,styled/* default */.Z)("div")({
    cursor: "pointer",
    marginLeft: 9,
    display: "flex"
});
var LoginButton = (0,styled/* default */.Z)(Button/* default */.Z)(function() {
    return {
        color: "#414046",
        borderColor: "#414046",
        height: 19,
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "1px",
        maxWidth: 180,
        textDecoration: "underline",
        "@media (max-width: 767px)": {
            fontSize: 12
        }
    };
});


// EXTERNAL MODULE: ./src/screens/menu/index.tsx
var menu = __webpack_require__(85393);
// EXTERNAL MODULE: ./src/components/icons/LogoMeki.tsx
var LogoMeki = __webpack_require__(73604);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/screens/cart/DrawerCart.tsx + 2 modules
var DrawerCart = __webpack_require__(24950);
// EXTERNAL MODULE: ./src/hooks/useFocusSearchBox.tsx
var useFocusSearchBox = __webpack_require__(31515);
// EXTERNAL MODULE: ./src/components/searchBox.tsx + 8 modules
var searchBox = __webpack_require__(14703);
;// CONCATENATED MODULE: ./src/screens/home/components/homeNavBar.tsx













function HomeNavBar(param) {
    var isVisible = param.isVisible, setIsVisible = param.setIsVisible;
    var ref, ref1, ref2;
    var ref3 = (0,useWindowSize/* useWindowSize */.i)(), width = ref3.width, isDesktop = ref3.isDesktop;
    var ref4 = (0,useAuth/* useAuth */.a)(), user = ref4.appUser;
    var router = (0,next_router.useRouter)();
    var focusSearchBox = (0,useFocusSearchBox/* useFocusSearchBox */.G)();
    var ref5 = (0,react.useState)(false), hideInfo = ref5[0], setHideInfo = ref5[1];
    var elevation = 1;
    (0,react.useEffect)(function() {
        if (isVisible && !isDesktop) {
            setHideInfo(true);
            return;
        }
        setHideInfo(false);
    }, [
        focusSearchBox,
        isVisible,
        isDesktop
    ]);
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderAppBar, {
            color: "primary",
            elevation: elevation,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderToolbar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionDivLeft, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderLeftDiv, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* DrawerMenu */.O, {}),
                                !hideInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(MekiLogoDiv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoMeki/* MekiLogo */.$, {
                                        fill: "#414046",
                                        height: "24px",
                                        width: "auto",
                                        onClick: function() {
                                            void router.push((0,utils/* getRoute */.Bv)("home"));
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(searchBox/* SearchBox */.R, {
                        isHeader: true,
                        isVisible: isVisible,
                        setIsVisible: setIsVisible
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionDivRight, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderRightComponent, {
                            children: [
                                !hideInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                                        size: "medium",
                                        onClick: function() {
                                            void router.push({
                                                pathname: "/ingresar",
                                                query: (0,utils/* removeUndefineds */.ox)((0,_object_spread/* default */.Z)({}, router.query))
                                            }, {
                                                pathname: "/ingresar"
                                            });
                                        },
                                        children: width >= 1110 ? "Iniciar sesi\xf3n" : "Inicia"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* DrawerMenu */.O, {
                                        isFromMenuName: "".concat((ref = user.name) === null || ref === void 0 ? void 0 : ref.split(" ")[0], " ").concat((ref6 = (ref1 = user.lastNames) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.toLocaleUpperCase()) !== null && ref6 !== void 0 ? ref6 : "", ".")
                                    })
                                }),
                                (isDesktop || !isDesktop && !focusSearchBox.isFocus) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerCart/* DrawerCart */.$, {})
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(52904); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);